module.exports = __webpack_public_path__ + "img/zahnarztpraxiskoblenz_5.80552651.jpg";